<script>
import metaInfo from '@/modules/mixins/metaInfo'
import { mapGetters } from 'vuex'
import RadioLine from '@/components/molecules/input/RadioLine'
import ModalEdit from '@/components/organism/modal/ModalEdit'
import ContentLine from '@/components/atoms/ContentLine'
import ButtonLoader from '@/components/atoms/ButtonLoader'

export default {
    name: 'General',
    components: {
        ButtonLoader,
        ContentLine,
        RadioLine,
        ModalEdit,
    },
    mixins: [metaInfo],
    data() {
        return {
            user: this.$user.model,
            emailRequestLoading: false,
            emailSent: false,
            info: null,
            editPhone: {
                label: 'labels.phone',
                inputLabel: 'labels.phone',
                validate: 'phone',
                validationType: 'phone',
                type: 'phone',
                key: 'phone',
                required: true,
            },
        }
    },
    computed: {
        ...mapGetters(['locales', 'locale', 'languageSelectorAvailable']),
        pageTitle() {
            return this.$t('profile.pages.general')
        },
        setLocale: {
            get() {
                return this.locale
            },
            set(val) {
                this.$store.dispatch('localeSet', val)
            },
        },
        editName() {
            return {
                label: 'labels.full_name',
                type: ['line', 'line'],
                required: [true, true],
                validate:
                    this.locale === 'hu'
                        ? ['last_name', 'first_name']
                        : ['first_name', 'last_name'],
                inputLabel:
                    this.locale === 'hu'
                        ? ['labels.last_name', 'labels.first_name']
                        : ['labels.first_name', 'labels.last_name'],
                key:
                    this.locale === 'hu'
                        ? ['last_name', 'first_name']
                        : ['first_name', 'last_name'],
            }
        },
    },
    methods: {
        openEditModal(input) {
            if (input) this.$refs.ModalEdit.open(input)
        },
        changePassword() {
            if (!this.emailSent) {
                this.emailRequestLoading = true
                this.$user
                    .sendResetEmail()
                    .then((res) => {
                        if (res.code === 202) {
                            this.info = this.$t('login.new_psw_info.info_text', {
                                date: this.$options.filters.toDateTime(res.message),
                            })
                        }
                    })
                    .finally(() => {
                        this.emailSent = true
                        this.emailRequestLoading = false
                    })
            }
        },
        async saveUser(user) {
            return await this.$user.update(user)
        },
    },
}
</script>

<template lang="pug">
.profile-general
    h2 {{ $t('profile.general_account_settings') }}
    .card.mb-8
        .card-body
            content-line(label="labels.full_name" @edit="openEditModal(editName)") {{ getFullName(user) }}
            content-line(label="labels.email" readonly) {{ user.email }}
            content-line(label="labels.phone" @edit="openEditModal(editPhone)") {{ user.phone }}
            content-line(v-if="user.company" label="labels.company" readonly) {{ user.company.name }}
            content-line(label="labels.psw" readonly)
                .d-flex.align-items-center
                    button-loader.btn.btn-primary.btn-xs(@click="changePassword" :disabled="emailSent" :loading="emailRequestLoading" inline) {{ $t("base.change") }}
                    transition(name="fade")
                        small.text-73.ml-3(v-if="emailSent" v-text="info || $t('profile.new_psw_info')")
    template(v-if="languageSelectorAvailable")
        h2 {{ $t('profile.language') }}
        .card.mb-8
            .card-body
                radio-line(v-for="(option, index) in locales" v-model="setLocale" :data="option" :key="`setLang-${index}`")
                    span.font-weight-semibold {{ $t(`base.languages.${option}`) }}
    modal-edit(v-model="user" :save="saveUser" ref="ModalEdit")

</template>
